import { CALENDAR_SELECTION_TYPE } from '@skyscanner/backpack-web/bpk-component-calendar';
import BpkDatepicker from '@skyscanner/backpack-web/bpk-component-datepicker';

import type { I18nService } from '@shared/types/i18n';

import { withI18n } from '@shared/ui/contexts/i18n';
import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';
import {
  minCheckInDate,
  minCheckOutDate,
  maxCheckInDate,
  maxCheckOutDate,
} from '@shared/utils-universal/guest-stay';
import { DATE_FORMAT } from '@shared/utils-universal/i18n/date-formats';

type Props = {
  i18n: I18nService;
  id: string;
  date: Date;
  startDate: Date;
  endDate: Date;
  isCheckOut: boolean;
  isOpen?: boolean;
  onDateSelect: Function;
  onOpenChange?: (isOpen: boolean) => void;
  inputProps?: {
    className?: string;
    disabled?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    ['data-testid']: string;
  };
  popperModifiers?: Array<{
    name: string;
    options: {
      enabled: boolean;
    };
  }>;
};

const DatePicker = ({
  date,
  endDate,
  i18n: { formatDate, getDaysOfWeek, getFirstDay, translate },
  id,
  isCheckOut,
  onDateSelect,
  onOpenChange,
  startDate,
  ...rest
}: Props) => {
  const selectionConfiguration = {
    type: CALENDAR_SELECTION_TYPE.single,
    date,
  };

  const handleDateSelect = (newDate: Date) => {
    onDateSelect(newDate);
  };

  const formatDateFull = (dt: Date) => formatDate(dt, DATE_FORMAT.FULL);

  const formatMonth = (dt: Date) => formatDate(dt, DATE_FORMAT.YEAR_MONTH);

  const daysOfWeek = getDaysOfWeek();
  const weekStartsOn = getFirstDay();

  let title;
  let minDate;
  let maxDate;
  if (isCheckOut) {
    title = translate('SearchControls_label_CheckOut');
    minDate = minCheckOutDate();
    maxDate = maxCheckOutDate();
  } else {
    title = translate('SearchControls_label_CheckIn');
    minDate = minCheckInDate();
    maxDate = maxCheckInDate();
  }

  return (
    <BpkDatepicker
      id={id}
      title={title}
      onOpenChange={onOpenChange}
      weekStartsOn={weekStartsOn}
      daysOfWeek={daysOfWeek}
      minDate={minDate}
      maxDate={maxDate}
      closeButtonText={translate('Modal_close')}
      changeMonthLabel={translate('HotelStay_label_changeMonth')}
      formatDate={formatDate}
      formatMonth={formatMonth}
      formatDateFull={formatDateFull}
      onDateSelect={handleDateSelect}
      selectionConfiguration={selectionConfiguration}
      getApplicationElement={getApplicationElement}
      {...rest}
    />
  );
};

export default withI18n(DatePicker);
